import { IconAlertCircle } from 'featherico';
import PropTypes from 'prop-types';
import Crossfade from '../../Crossfade';
import styles from './style.m.less';

InputSubLabel.propTypes = {
    children: PropTypes.node,
    show: PropTypes.bool.isRequired,
    isError: PropTypes.bool.isRequired,
};

export function InputSubLabel({ children, show, isError }) {
    return (
        <Crossfade>
            {show ? (
                <div className={isError ? styles.error : styles.label} key="label">
                    {isError && <IconAlertCircle />} {children}
                </div>
            ) : (
                <noscript key="noLabel" />
            )}
        </Crossfade>
    );
}
